import { useFeatureFlag } from 'util/featureFlags'

export const useExcludedWeatherDatasets = () => {
  // Feature flags for weather datasets
  const enableNrelPsmV4 = useFeatureFlag('enable_nrel_psm_v4', 'on')
  const enableCsiro = useFeatureFlag('enable_csiro_weather', 'on')
  const enableHimawari = useFeatureFlag('enable_himawari_weather', 'on')
  const enableSunyIndia = useFeatureFlag('enable_suny_india_weather', 'on')

  const datasetsToFilter: number[] = []

  if (!enableNrelPsmV4) {
    datasetsToFilter.push(2) // NREL PSM4
  }

  if (!enableCsiro) {
    datasetsToFilter.push(3) // CSIRO
  }

  if (!enableHimawari) {
    datasetsToFilter.push(4) // Himawari PSM3
  }

  if (!enableSunyIndia) {
    datasetsToFilter.push(5) // SUNY India
  }

  return datasetsToFilter
}
